/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import ShowComponent from '../../hocs/ShowComponent';
import TriangleComponent from '../../shared_components/TriangleComponent';
import PlusComponent from '../../shared_components/PlusComponent';
import MinusComponent from '../../shared_components/MinusComponent';

@ShowComponent
class AddDifferenceToComponent extends React.Component {
  render() {
    let differenceToAdd;
    let button;

    /* If difference is positive */
    if (Number(this.props.mortgageLoanpartsDifference) > 0) {
      differenceToAdd = this.props.mortgageLoanpartsDifference;
      button = (
        <div className="add-difference-to-loanpart__button">
          <PlusComponent />
        </div>
      );

      /* If difference is negative compare to loanpart */
    } else if (Number(this.props.mortgageLoanpartsDifference < 0)) {
      if (Number(this.props.grossValue) <= Math.abs(Number(this.props.mortgageLoanpartsDifference))) {
        button = (
          <div className="add-difference-to-loanpart__button">
            <MinusComponent />
          </div>
        );

        differenceToAdd = 0;
      } else if (Number(this.props.grossValue) >= Math.abs(Number(this.props.mortgageLoanpartsDifference))) {
        differenceToAdd = this.props.mortgageLoanpartsDifference;
      }
    }

    /* If amount to remove is zero, change message shown */
    let defaultText = `€ ${numeral(differenceToAdd).format('0,0[.]00')}`;

    if (differenceToAdd === 0) {
      defaultText = 'Leningdeel verwijderen';
    }

    return (
      <div onClick={this.props.onClickHandler} className="add-difference-to-loanpart">
        <TriangleComponent
          classNames={'add-difference-to-loanpart__triangle'}
        />
        {button}
        <div className="add-difference-to-loanpart__amount">
          {defaultText}
        </div>
      </div>
    );
  }
}

AddDifferenceToComponent.propTypes = {
  onClickHandler: PropTypes.func,
  mortgageLoanpartsDifference: PropTypes.number,
  grossValue: PropTypes.number,
};

AddDifferenceToComponent.defaultProps = {
  onClickHandler: () => {},
  mortgageLoanpartsDifference: 0,
  grossValue: 0,
};

export default AddDifferenceToComponent;
